export const styles = {
    centerFlex: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    },
    divider: {
        borderColor: '#CDD2DC',
        mx: 3,
    },
    toolBar: {
        alignItems: 'center',
        display: 'flex',
        pl: 3,
        py: 1,
        boxShadow: '0px 1px 2px rgba(9, 30, 66, 0.12)',
    },
    appBar: {
        backgroundColor: 'background.default',
    },
    flexGrow: {
        flexGrow: 1,
    },
    tableMenuDialog: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
};
